<template lang="pug">
  Accordion.faq-accordion(:initActive="0")
    AccordionItem.faq-accordion__topic(
      v-for="category in categories"
      :key="category.id"
      hideArrow
    )
      template(#accordion-trigger)
          h3 {{ category.name }}
      template(#accordion-content)
        Accordion
          AccordionItem.faq-accordion__question(
          v-for="item in getItemsByCategory(category)"
          :key="item.id"
          )
            template(#accordion-trigger="{isVisible}")
              h3 {{ item.question }}
            template(#accordion-content)
              span(v-html="item.answer")
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Accordion from '@/components/accordion/Accordion'
import AccordionItem from '@/components/accordion/AccordionItem'

export default {
  name: 'FaqCategories',
  components: {
    Accordion,
    AccordionItem
  },
  computed: {
    ...mapState('faqs', {
      selectedCategory: 'category'
    }),
    ...mapGetters('faqs', ['getItemsByCategory', 'categories'])
  }
}
</script>
